import axios from 'axios';
import {
  CREATE_ORGANIZATION_FAILURE,
  CREATE_ORGANIZATION_SUCCESS,
  CREATING_ORGANIZATION, FETCH_ORGANIZATION,
  FETCH_ORGANIZATIONS_SUCCESS, FETCHING_ORGANIZATION,
  FETCHING_ORGANIZATIONS, UPDATE_ORGANIZATION_SUCCESS, UPDATING_ORGANIZATION,
  SAVE_ORGANIZATION_SUCCESS,
  SAVE_ORGANIZATION_FAILURE,
  SAVING_ORGANIZATION,
  CLEAR_ORGANIZATION_FLAG,
  FETCH_ORGANIZATION_FAILURE
} from './OrganizationsConstants';

const path = 'utm/v1/organizations';

const fetchingOrganizations = () => ({ type: FETCHING_ORGANIZATIONS });
const fetchOrganizationsSuccess = organizations => ({ type: FETCH_ORGANIZATIONS_SUCCESS, organizations });
const creatingOrganization = () => ({ type: CREATING_ORGANIZATION });
const createOrganizationSuccess = () => ({ type: CREATE_ORGANIZATION_SUCCESS });
const createOrganizationFailure = () => ({ type: CREATE_ORGANIZATION_FAILURE });
const fetchingOrganization = () => ({ type: FETCHING_ORGANIZATION });
const fetchOrganizationSuccess = organization => ({ type: FETCH_ORGANIZATION, organization });
const fetchOrganizationFailure = () => ({ type: FETCH_ORGANIZATION_FAILURE});
const updateOrganizationSuccess = organization => ({ type: UPDATE_ORGANIZATION_SUCCESS, organization });
const updatingOrganization = () => ({ type: UPDATING_ORGANIZATION });
const savingOrganization = () => ({ type: SAVING_ORGANIZATION });
const saveOrganizationSuccess = () => ({ type: SAVE_ORGANIZATION_SUCCESS });
const saveOrganizationFailure = () => ({ type: SAVE_ORGANIZATION_FAILURE });
export const clearOrganizationFlags = () => ({ type: CLEAR_ORGANIZATION_FLAG});

export const fetchOrganizations = () => dispatch => {
  dispatch(fetchingOrganizations());
  axios.get(path)
    .then(organizationsResponse => {
      dispatch(fetchOrganizationsSuccess(organizationsResponse.data.data));
    })
    .catch(error => {
      throw error;
    });
};

export const addOrganization = organization => dispatch => {
  dispatch(creatingOrganization());
  axios.post(path, organization)
    .then(response => {
      if(response.status === 200) {
        dispatch(createOrganizationSuccess());
        dispatch(fetchOrganizations());
      }
      else {
        console.log(response.message);
        dispatch(createOrganizationFailure());
      }
    })
    .catch(error => { throw error; });
};

export const updateOrganization = organization => dispatch => {
  dispatch(updatingOrganization());
  const org = { ...organization  };
  if(org.gtdPassword === '***') {
    delete org.gtdPassword;
  }
  if(org.gtdHmac === '***') {
    delete org.gtdHmac;
  }
  axios.put(path, org)
    .then(response => {
      dispatch(updateOrganizationSuccess(response.data.data));
    })
    .catch(error => { throw error; });
};

export const fetchOrganization = () => dispatch => {
  dispatch(fetchingOrganization());
  axios.get(`${ path }`)
    .then(response => {
      if (response.data.status !== 200) {
        dispatch(fetchOrganizationFailure());
      } else {
        const { id, code, gtdUser, isGtdPasswordSet, isGtdHmacSet } = response.data.data;
        dispatch(fetchOrganizationSuccess({ id, code, gtdUser, isGtdPasswordSet, isGtdHmacSet }));
      }

    })
    .catch(error => { throw error; });
};

export const saveOrganization = (gtdOrgCode, gtdUser, gtdPswrd, gtdHmac) => async dispatch => {
  const organization = {
    gtdUser,
    gtdPswrd,
    gtdHmac,
    gtdOrgCode
  };
  dispatch(savingOrganization());
  const response = await axios.post(`${path}`, organization);
  if ( response.data.status === 200 ) {
    await dispatch(saveOrganizationSuccess());
  } else {
    await dispatch(saveOrganizationFailure());
  }
};




// WEBPACK FOOTER //
// ./src/redux/organizations/OrganizationsActions.js